import { post, get } from '@/utils/http/http'
import { LIVE_GW_URL, BILL_URL, SHOP_URL } from '@/utils/http/baseUrl'

/**
 * * 批量查询获取门店商品的库存数据
 */
export const getClientProductStocks = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/product/getStocks`, params)

/**
 * * 客户端库存列表查询
 * @param {Object} params - 请求参数
 * @param {number[]} params.storeIds - 要查询的门店ID列表（必需）
 * @param {string} [params.productName] - 商品名称（模糊查询）
 * @param {number} [params.pageIndex=1] - 页码
 * @param {number} [params.pageSize=10] - 每页大小
 * @returns {Promise} 返回库存分页列表
 * */
export const erpStockListPage = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/stock/listPage`, params, false)
// post('http://192.168.64.242:8787/test/shop/erp/client/store/stock/listPage', params, false)

/**
 * * 客户端库存变动记录查询
 * @param {Object} params - 请求参数
 * @param {number[]} params.storeIds - 要查询的门店ID列表（必需）
 * @param {string} [params.productName] - 商品名称（模糊查询）
 * @param {string} [params.createTimeStart] - 开始创建时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {string} [params.createTimeEnd] - 结束创建时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {number} [params.pageIndex=1] - 页码
 * @param {number} [params.pageSize=10] - 每页大小
 * @returns {Promise} 返回库存变动记录分页列表
 * */
export const erpStockLogPage = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/stock/log/listPage`, params, false)
// post('http://192.168.64.242:8787/test/shop/erp/client/store/stock/log/listPage', params, false)

/**
 * * 客户端配送差异详情
 * @param {Object} params - 请求参数
 * @param {number} params.id - 配送差异记录ID（必需）
 * @returns {Promise} 返回配送差异详情视图对象
 * */
export const getErpDeliveryDiffDetail = params =>
  get(`${LIVE_GW_URL}/shop/erp/client/delivery/diff/detail`, params, false)

/**
 * * 客户端举证详情
 * @param {Object} params - 请求参数
 * @param {number} params.id - 举证记录ID（必需）
 * @returns {Promise} 返回举证详情视图对象，包含举证图片、描述等信息
 * */
export const getErpDeliveryDiffEvidenceDetail = params =>
  get(
    `${LIVE_GW_URL}/shop/erp/client/delivery/diff/evidence/detail`,
    params,
    false
  )

/**
 * * 举证资料提交
 * @param {Object} params - 请求参数
 * @param {number} params.deliveryDiffId - 配送差异ID（必需）
 * @param {string} params.evidenceDesc - 举证描述（必需）
 * @param {string[]} params.evidenceImgs - 举证图片URL列表（必需）
 * @param {number} params.evidenceType - 举证类型：1=少货，2=破损（必需）
 * @returns {Promise<boolean>} 返回是否提交成功
 * */
export const erpDeliveryDiffEvidenceSubmit = params =>
  post(
    `${LIVE_GW_URL}/shop/erp/client/delivery/diff/evidence/submit`,
    params,
    false
  )

/**
 * * 客户端配送差异列表
 * @param {Object} params - 请求参数
 * @param {number[]} params.storeIds - 要查询的门店ID列表（必需）
 * @param {string} [params.createTimeStart] - 开始创建时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {string} [params.createTimeEnd] - 结束创建时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {number} [params.evidenceStatus] - 举证状态：0=未举证，1=已举证
 * @param {string} [params.deliveryNo] - 配送单号（模糊查询）
 * @param {number} [params.pageIndex=1] - 页码
 * @param {number} [params.pageSize=10] - 每页大小
 * @returns {Promise} 返回配送差异记录分页列表
 * */
export const erpDeliveryDiffListPage = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/delivery/diff/listPage`, params, false)

/**
 * * 审核门店入库记录
 * @param {Object} params - 请求参数
 * @param {number} params.auditStatus - 审核状态
 * @param {number} params.id - 记录ID
 * */
export const erpStoreInRecAudit = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/inRec/audit`, params, false)

/**
 * * 获取门店入库记录详情
 * @param {Object} params - 请求参数
 * @param {number} params.id - 记录ID
 * @returns {Promise} 返回门店入库记录视图对象，包含入库单基本信息、商品明细列表、审核状态等
 * */
export const getErpStoreInRecById = params =>
  get(`${LIVE_GW_URL}/shop/erp/client/store/inRec/getById`, params, false)

/**
 * * 分页查询门店入库记录列表
 * @param {Object} params - 请求参数
 * @param {number[]} params.storeIds - 要查询的门店ID列表（必需）
 * @param {number} [params.auditStatus] - 审核状态：0=未审核，1=已审核，2=已作废
 * @param {string} [params.createTimeStart] - 开始创建时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {string} [params.createTimeEnd] - 结束创建时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {string} [params.inNo] - 入库单号 (模糊查询)
 * @param {number} [params.inSubType] - 入库子类型：0=配送入库，1=手动入库...
 * @param {number} [params.pageIndex=1] - 页码
 * @param {number} [params.pageSize=10] - 每页大小
 * @returns {Promise} 返回ERP单据分页及统计视图对象
 * */
export const erpStoreInRecPage = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/inRec/page`, params, false)

/**
 * * 新增或修改门店入库记录
 * @param {Object} params - 请求参数
 * @param {Object[]} params.items - 入库商品明细列表（必需）
 * @param {number} params.items[].beforeQty - 入库前库存数量（必需）
 * @param {number} params.items[].productId - 商品ID（必需）
 * @param {number} params.items[].qty - 入库数量，最小值为1（必需）
 * @param {string} params.items[].skuName - 商品编码名称（必需）
 * @param {number} [params.items[].id] - 明细ID，更新时传入
 * @param {number} [params.id] - 入库单ID (更新时必填)
 * @param {number} [params.auditStatus] - 审核状态：0=未审核，1=已审核
 * @param {number} [params.createdBy] - 创建人ID
 * @param {string} [params.inNo] - 入库单号
 * @param {number} [params.inSubType] - 入库子类型：0=配送入库，1=手动入库，2=退货入库，3=盘点入库，4=恢复入库
 * @param {string} [params.inTime] - 入库时间
 * @param {string} [params.relatedNo] - 关联单号，发货单
 * @param {string} [params.remark] - 备注
 * @param {number} [params.status] - 状态：-1=删除，0=待入库，1=已入库，2=已作废
 * @param {number} [params.storeId] - 门店ID
 * @param {number} [params.updatedBy] - 更新人ID
 * @param {number} [params.zbId] - 直播间ID
 * @returns {Promise} 返回入库单ID
 * */
export const erpStoreInRecSaveOrUpdate = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/inRec/saveOrUpdate`, params, false)

/**
 * * 修改入库单备注 (审核后也可修改)
 * @param {Object} params - 请求参数
 * @param {number} params.id - 入库单ID
 * @param {string} params.remark - 备注内容
 * @returns {Promise<boolean>} 返回是否修改成功
 * */
export const erpStoreInRecUpdateRemark = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/inRec/updateRemark`, params, false)

/**
 * * 审核门店出库记录
 * @param {Object} params - 请求参数
 * @param {number} params.auditStatus - 审核状态
 * @param {number} params.id - 记录ID
 * @returns {Promise<boolean>} 返回是否审核成功
 * */
export const erpStoreOutRecAudit = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/outRec/audit`, params, false)

/**
 * * 分页查询门店出库记录列表
 * @param {Object} params - 请求参数
 * @param {number[]} params.storeIds - 要查询的门店ID列表（必需）
 * @param {number} [params.auditStatus] - 审核状态：0=未审核，1=已审核，2=已作废
 * @param {string} [params.createTimeStart] - 开始创建时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {string} [params.createTimeEnd] - 结束创建时间 (格式: yyyy-MM-dd HH:mm:ss)
 * @param {string} [params.outNo] - 出库单号 (模糊查询)
 * @param {number} [params.outSubType] - 出库子类型：0=核销出库，1=退货出库...
 * @param {number} [params.pageIndex=1] - 页码
 * @param {number} [params.pageSize=10] - 每页大小
 * @returns {Promise} 返回ERP单据分页及统计视图对象
 * */
export const erpStoreOutRecPage = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/outRec/page`, params, false)

/**
 * * 新增或修改门店出库记录
 * @param {Object} params - 请求参数
 * @param {Object[]} params.items - 出库商品明细列表（必需）
 * @param {number} params.items[].productId - 商品ID（必需）
 * @param {number} params.items[].qty - 出库数量，最小值为1（必需）
 * @param {string} params.items[].skuName - 商品编码名称（必需）
 * @param {number} [params.items[].id] - 明细ID，更新时传入
 * @param {number} [params.id] - 主键ID (更新时必填)
 * @param {number} [params.auditStatus] - 审核状态：0=未审核，1=已审核
 * @param {number} [params.createdBy] - 创建人ID
 * @param {string} [params.outNo] - 出库单号
 * @param {number} [params.outSubType] - 出库子类型：0=核销出库，1=退货出库，2=盘点出库
 * @param {string} [params.outTime] - 出库时间
 * @param {string} [params.relatedNo] - 关联单号
 * @param {string} [params.remark] - 备注
 * @param {number} [params.status] - 状态：-1=删除，0=待出库，1=已出库，2=已作废
 * @param {number} [params.storeId] - 门店ID
 * @param {number} [params.updatedBy] - 更新人ID
 * @param {number} [params.zbId] - 直播间ID
 * @returns {Promise<number>} 返回出库单ID
 * */
export const erpStoreOutRecSaveOrUpdate = params =>
  post(
    `${LIVE_GW_URL}/shop/erp/client/store/outRec/saveOrUpdate`,
    params,
    false
  )

/**
 * * 获取出库单详情
 * /shop/erp/client/store/outRec/getById
 */
export const getErpStoreOutRecById = params =>
  get(`${LIVE_GW_URL}/shop/erp/client/store/outRec/getById`, params, false)

/**
 * * 修改出库单备注 (审核后也可修改)
 * @param {Object} params - 请求参数
 * @param {number} params.id - 出库单ID
 * @param {string} params.remark - 备注内容
 * @returns {Promise<boolean>} 返回是否修改成功
 * */
export const erpStoreOutRecUpdateRemark = params =>
  post(
    `${LIVE_GW_URL}/shop/erp/client/store/outRec/updateRemark`,
    params,
    false
  )

/**
 * * 代理员获取已绑定的门店数据
 */
export const getLowerAgentStoreInfoOneSelf = params =>
  post(
    `${LIVE_GW_URL}/health/v1/h5/agent-data/getLowerAgentStore`,
    params,
    false
  )

/**
 * * 退货单列表
 */
export const erpRefundList = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/refund/listRefund`, params, false)

/**
 * * 退货单详情
 */
export const erpRefundDetail = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/refund/detial`, params, false)

/**
 * * 退货单统计
 */
export const erpRefundStat = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/refund/refundStat`, params, false)

/**
 * * 保存退货单
 */
export const saveErpRefundRec = params =>
  post(
    `${LIVE_GW_URL}/shop/erp/client/store/refund/saveRefundRec`,
    params,
    false
  )

/**
 * * 保存退货单（备注）
 */
export const saveErpReUpdateRemark = params =>
  post(
    `${LIVE_GW_URL}/shop/erp/client/store/refund/updateRemark`,
    params,
    false
  )

/**
 * * 保存退货单 - 物流信息
 */
export const saveErpDelivery = params =>
  post(
    `${LIVE_GW_URL}/shop/erp/client/store/refund/saveDelivery`,
    params,
    false
  )

/**
 * * 审核盘点记录，审核通过后触发入-出库单及明细生成
 */
export const erpCheckRecAudit = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/checkRec/audit`, params, false)

/**
 * * 软删除盘点记录
 */
export const erpCheckRecDelete = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/checkRec/delete`, params, false)

/**
 * * 获取门店盘点记录详情
 */
export const getErpCheckRecDetail = params =>
  get(`${LIVE_GW_URL}/shop/erp/client/store/checkRec/getById`, params, false)

/**
 * * 分页查询门店盘点记录列表
 */
export const erpCheckRecPage = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/store/checkRec/page`, params, false)

/**
 * * 新增或更新盘点记录
 */
export const erpCheckRecSave = params =>
  post(
    `${LIVE_GW_URL}/shop/erp/client/store/checkRec/saveOrUpdate`,
    params,
    false
  )

/**
 * * 修改盘点单备注 (所有状态下均可修改)
 */
export const erpCheckRecUpdateRemark = params =>
  post(
    `${LIVE_GW_URL}/shop/erp/client/store/checkRec/updateRemark`,
    params,
    false
  )

/**
 * * 在途配送 - 确认送达
 */
export const ConfirmDelivered = params =>
  post(
    `${BILL_URL}/api/AgentDeliveryProcure/v2/ConfirmDelivered`,
    params,
    false
  )

/**
 * * 更新商品在指定门店的上下架状态（需Admin权限）
 */
export const productUpdateShelfStatus = params =>
  post(
    `${LIVE_GW_URL}/shop/erp/client/product/updateShelfStatus`,
    params,
    false
  )

/**
 * * 规格明细
 */
export const getSkuDetails = params =>
  post(
    `${LIVE_GW_URL}/shop/erp/client/store/stock/getSkuDetails`,
    params,
    false
  )

/**
 * * 线下商城 - 生成支付码
 */
export const getPaycode = params =>
  post(`${SHOP_URL}/api/agent/offline/paycode`, params, false)

/**
 * * 线下商城 - 商品列表
 */
export const getProductsList = params =>
  post(`${SHOP_URL}/api/agent/store/offline/productlist`, params, false)

/**
 * 代理中心 erp模块 - 获取商品列表
 */
export const getProducts = params =>
  get(`${LIVE_GW_URL}/shop/erp/client/product/getProducts`, params, false)

/**
 * 代理中心 erp模块 - 根据商品ID获取SKU规格树
 */
export const getProductSku = params =>
  get(`${LIVE_GW_URL}/shop/erp/client/product/getProductSku`, params, false)

/**
 * * 线下商城 - 设置
 */
export const setOfflineSetting = params =>
  post(`${SHOP_URL}/api/agent/store/offline/set`, params, false)

/**
 * * 线下商城 - 获取设置
 */
export const getOfflineSetting = (zbId, storeId) =>
  get(`${SHOP_URL}/api/agent/store/offline/${zbId}/${storeId}`)

/**
 * * 设置代理门店功能配置
 * @param {Object} params - 请求参数
 * @returns {Promise} 返回设置结果
 */
export const setStoreFunc = params =>
  post(`${SHOP_URL}/api/agent/storefunc/set`, params, false)

/**
 * * 获取代理门店功能配置
 * @param {Object} params - 请求参数
 * @param {string} params.zbId - 直播间ID
 * @param {string} params.storeId - 门店ID
 * @returns {Promise} 返回门店功能配置信息
 */
export const getStoreFunc = params =>
  get(`${SHOP_URL}/api/agent/storefunc/${params.zbId}/${params.storeId}`)

/**
 * * 获取代理门店功能配置
 * @param {Object} params - 请求参数
 * @param {string} params.zbid - 直播间ID
 * @returns {Promise} 返回erp相关功能配置信息
 */
export const getErpConfig = params => get(`${SHOP_URL}/api/erp/${params.zbid}`)

/**
 * 获取物流轨迹
 */
export const getlogistics = params =>
  post(`${SHOP_URL}/api/erp/getlogistics`, params, false)

/**
 * * 核销出库记录数据
 */
export const getVerifyOut = params =>
  post(`${SHOP_URL}/api/erp/verifyout/records`, params, false)

/**
 * * 核销入库记录数据
 */
export const getVerifyin = params =>
  post(`${SHOP_URL}/api/erp/verifyin/records`, params, false)
// post(`http://192.168.64.242:8787/test/data`, params, false)

/**
 * * 个人配送列表
 */
export const getDriverPackageList = params =>
  post(`${BILL_URL}/api/Driver/package/list`, params, false)

/**
 * * 个人配送信息
 */
export const getDriverPackageBase = zbId =>
  get(`${BILL_URL}/api/Driver/package/base/${zbId}`, {}, false, {
    allRes: true,
  })

/**
 * * 个人配送详情
 */
export const getDriverPackageDetail = params =>
  post(`${BILL_URL}/api/Driver/package/info`, params, false)

/**
 * * 装车
 */
export const driverPackageOut = params =>
  post(`${BILL_URL}/api/Driver/package/out`, params, false)

/**
 * * 确认送达
 */
export const driverPackageDelivered = params =>
  post(`${BILL_URL}/api/Driver/package/delivered`, params, false)

/**
 * * 成为司机
 */
export const becomeDriver = params =>
  post(`${SHOP_URL}/api/driver/turninto`, params, true, { allRes: 1 })

/**
 * * 是否是司机
 */
export const isDriver = id =>
  get(`${SHOP_URL}/api/driver/isdriver/${id}`, {}, true, { allRes: 1 })

/**
 * * Erp前置仓配送相关接口
 */
export const erpDeliveryFront = {
  // 列表
  getList: params =>
    post(`${BILL_URL}/api/ErpDeliveryFront/GetDeliveryList`, params, false),

  // 详情
  getDetail: params =>
    post(
      `${BILL_URL}/api/ErpDeliveryFront/GetDeliveryStoreDetails`,
      params,
      false
    ),

  // 获取物流信息
  getLogistics: params =>
    get(`${SHOP_URL}/api/erpdeliveryfront/getlogistics`, params, false),

  // 导出
  exportOrder: params =>
    post(`${BILL_URL}/api/ErpDeliveryFront/ExportOrder`, params, false),

  // 确认
  confirmDelivered: params =>
    post(`${BILL_URL}/api/ErpDeliveryFront/ConfirmDelivered`, params, false),
}

/**
 * * Erp 预分拣核销相关接口
 */
export const erpPickIng = {
  // 获取分拣单信息
  goods: params => post(`${SHOP_URL}/api/erp/picking/goods`, params, false),

  // 分拣核销
  verify: params => post(`${SHOP_URL}/api/erp/picking/verify`, params, false),
}

/**
 * * Erp总部仓配送
 */
export const erpDeliveryParent = {
  // 列表
  getList: params =>
    post(`${BILL_URL}/api/ErpDeliveryParent/GetDeliveryList`, params, false),

  // 详情
  getDetail: params =>
    post(
      `${BILL_URL}/api/ErpDeliveryParent/GetDeliveryStoreDetails`,
      params,
      false
    ),

  // 获取物流信息
  getLogistics: params =>
    get(`${SHOP_URL}/api/erpdeliveryparent/getlogistics`, params, false),

  // 导出
  exportOrder: params =>
    post(`${BILL_URL}/api/ErpDeliveryParent/ExportOrder`, params, false),

  // 确认
  confirmDelivered: params =>
    post(`${BILL_URL}/api/ErpDeliveryParent/ConfirmDelivered`, params, false),
}

/**
 ** 获取分拣员信息
 */
export const getStoreManInfo = params =>
  get(`${LIVE_GW_URL}/shop/erp/client/sorter/getByUid`, params)

/**
 * 新增编辑分拣员
 */
export const editStoreMan = params =>
  post(`${LIVE_GW_URL}/shop/erp/client/sorter/edit`, params)
export const getRefundGoodsScope = params =>
  get(
    `${LIVE_GW_URL}/shop/erp/client/store/refund/getRefundSetting`,
    params,
    false
  )
